import { Link } from "react-router-dom";
import { Seo } from "../components/site/Seo";
import { SITE, TEL } from "../lib/site";

export default function NotFound() {
  return (
    <>
      <Seo title="Page introuvable | A+GLASS Pare-Brise HAGUENAU" description="Cette page n'existe pas ou a été déplacée." path="/404" noindex />
      <section className="relative grid min-h-[80vh] place-items-center overflow-hidden bg-ag-ink px-5 pt-24 text-white" data-testid="not-found-page">
        <div className="pointer-events-none absolute h-[620px] w-[620px] rounded-full border border-dashed border-white/15" />
        <div className="relative text-center">
          <p className="font-display text-[8rem] font-extrabold leading-none text-ag-yellow sm:text-[12rem]">404</p>
          <h1 className="mt-2 font-display text-3xl font-extrabold sm:text-4xl">Cette page a pris un impact.</h1>
          <p className="mx-auto mt-4 max-w-md text-slate-300">La page demandée n'existe pas ou a été déplacée.</p>
          <div className="mt-8 flex flex-wrap justify-center gap-3">
            <Link to="/" className="btn btn-yellow" data-testid="not-found-home-link">Retour à l'accueil</Link>
            <a href={TEL} className="btn btn-outline-light" data-testid="not-found-call-link">Appeler le {SITE.phone}</a>
          </div>
        </div>
      </section>
    </>
  );
}
